module.exports = __webpack_public_path__ + "static/media/logo-amorc.19662d42.png";